import { nanoid } from 'nanoid';
import ticketTypes from '../../consts/ticketTypes';
import { FILTER_TABS } from '../../components/CRM/Tickets/TicketFilters/constants';

const initialMeta = {
  page: 1,
  size: 50,
  total: 0,
  totalPages: 1,
};

export const initialState = {
  activeTicket: null,
  prevActiveTicketId: null,
  prevActiveTicketClientId: null,
  isLoadingActiveTicket: false,
  activeTicketId: null,
  excessTickets: [],
  filters: {
    [FILTER_TABS.ACTUAL]: {},
    [FILTER_TABS.PLANNED]: {},
  },
  initialFilters: {
    [FILTER_TABS.ACTUAL]: {},
    [FILTER_TABS.PLANNED]: {},
  },
  prevFilters: {
    [FILTER_TABS.ACTUAL]: {},
    [FILTER_TABS.PLANNED]: {},
  },
  ticketsSort: 'DESC',
  prevTicketsSort: 'DESC',
  activeTicketsTab: FILTER_TABS.ACTUAL,
  options: {
    clients: [],
    closeReasons: [],
    countries: [],
    departures: [],
    destinations: [],
    hotelMeals: [],
    mailGroups: [],
    skillGroups: [],
    managers: [],
    menuSources: [],
    orders: [],
    partners: [],
    planReasons: [],
    segments: [],
    sources: [],
    statuses: [],
    suggestedOrders: [],
    tags: [],
    templates: [],
    types: ticketTypes,
  },
  errors: {},
  tickets: [],
  ticketIds: {},
  isFirstTimeLoading: false,
  isNextPageLoading: false,
  isCreateTicketLoading: false,
  isTicketReservationLoading: false,
  ticketListMeta: initialMeta,
  unassignedCountsByMailGroups: [],
};
